import React, { useEffect, useRef } from 'react';
import Message from './Message';

/**
 * Auto-scrolls to the latest message on every append. Scrolls the internal
 * container, not the window — important for the bubble layout where the
 * outer page must stay put.
 */

export default function MessageList({ messages }) {
  const endRef = useRef(null);

  const lastText = messages[messages.length - 1]?.text;
  useEffect(() => {
    if (!endRef.current) return;
    endRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }, [messages.length, lastText]);

  return (
    <div
      data-drishti="message-list"
      role="log"
      aria-live="polite"
      aria-relevant="additions"
      className="flex flex-col gap-3 overflow-y-auto"
    >
      {messages.map((m) => (
        <Message key={m.id} message={m} />
      ))}
      <div ref={endRef} />
    </div>
  );
}
